import { Record, List } from 'immutable';

const defaultValues = {
  tableName: '',
  srcCount: 0,
  destCount: 0,

};

export default class AssetTransferStat extends Record(defaultValues, AssetTransferStat) {
  constructor(values) {
    super({
      ...values,
    });
  }
}


export const AssetTransferStats = (data) => {
  let assetTransferStat = new List();
  if (data) {
    data.forEach((value) => {
      assetTransferStat = assetTransferStat.push(new AssetTransferStat(value));
    });
  }
  return assetTransferStat;
};
